var fgCodes = {
  underline     : 4,
  bold          : 1,
  italic        : 2,
  strikeout     : 9,
  gray          : 37,
  white         : 37,
  black         : 30,
  blue          : 34,
  cyan          : 36,
  green         : 32,
  magenta       : 35,
  red           : 31,
  yellow        : 33,
  brightBlack   : 90,
  brightRed     : 91,
  brightGreen   : 92,
  brightYellow  : 93,
  brightBlue    : 94,
  brightMagenta : 95,
  brightCyan    : 96,
  brightWhite   : 97,
}

var ansi = {};
Object.keys(fgCodes).forEach(function (k) {
  var o = '\u001b[' + fgCodes[k] + 'm';
  var c = '\u001b[39m\u001b[0m';

  ansi[k] = function (s) {
    return o + s + c;
  };
});

module.exports = ansi;

